import { cn } from '../../lib/utils';
import { isPhiMasked, phiMask } from '../../utils/phiUtils';
import { usePhiMaskedFields } from '../../contexts/PhiContext';

function Field({ name, value, className, ...rest }) {
  const maskedFields = usePhiMaskedFields();
  if (isPhiMasked(name, maskedFields)) {
    return (
      <span className={cn('font-mono tracking-widest text-muted-foreground', className)} {...rest}>
        {phiMask(name)}
      </span>
    );
  }
  return <span className={cn(className)} {...rest}>{value ?? '—'}</span>;
}

export { Field };
